<div class="container">
  <form [formGroup]="radioForm">
    <div
      class="item-group"
      *ngFor="let group of itemGroups"
      [ngClass]="{disabled: group.disabled}"
      [title]="group.tooltip || ''"
      [attr.data-automation-e2e-selector]="group.id"
    >
      <ul>
        <li
          *ngFor="let item of group.items"
          class="item"
          [ngClass]="{disabled: group.disabled}"
        >
          <div class="c-radio">
            <input
              class="hide"
              type="radio"
              [id]="item.id || group.id + '-all'"
              [formControlName]="group.id"
              [value]="item.id"
            />
            <label
              [for]="item.id || group.id + '-all'"
              [textContent]="item.caption"
            ></label>
          </div>
        </li>
      </ul>
    </div>
  </form>
</div>
